var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{on:{"click":function($event){return _vm.$vuetify.goTo(_vm.item.link, {
      offset: _vm.$store.state.section.stickyHeader.height
    })}}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.item.name))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }